import { useTranslation } from "react-i18next";
import { ProductReportsTableItem } from "./ProductReportsTableItemFilter";

export const ProductReportsTable = ({ reportData }) => {
    const [t] = useTranslation('global');
  
    return (
      <div className='m-5 rounded-lg bg-white border border-gray-200 sticky top-0 z-10'>
        <div className="grid grid-cols-12 gap-3 px-2 mt-2 bg-white font-bold text-[#251658] text-sm rounded-t-2xl justify-between items-center border-b py-4">
          <div className="text-center col-span-1">#</div>
          <div className="text-center col-span-1">{t("product.code")}</div>
          <div className="text-center col-span-2">{t("product.name")}</div>
          <div className="text-center col-span-3"></div>
           <div className="text-center col-span-2">{t("product.price")}</div>
          <div className="text-center col-span-1">{t("product.quantity")}</div>
          <div className="text-center col-span-2">{t("product.category")}</div>
        </div>
         
        <div className='max-h-[calc(100vh-200px)]overflow-y-scroll custom-scrollbar'>
          {reportData.data.map((item, index) => (
            <ProductReportsTableItem key={item.id} item={item} index={index} />
          ))}
        </div>
      </div>
    );
  };